import { Collapse } from '@mui/material'
import CattlesList from 'components/cattles/cattlesPage/ui/CattlesList'
import DigitizationWidjet from 'components/cattles/cattlesPage/ui/DigitizationWidjet'
import PageContainer from 'layouts/PageContainer'
import { useEffect } from 'react'
import { fetchDailyStatistics } from 'store/cattlesSlice'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { hideDigitizationUi } from 'utils/companyDigitizationFeatures'
import RepeatIdentifiedCard from './ui/RepeatIdentifiedCard'

const CattlesPage = () => {
	const activeFilter: string | number = 'all'
	const dispatch = useAppDispatch()
	const { permissions } = useAppSelector(state => state.authReducer)
	const { userData } = useAppSelector(state => state.userReducer)
	const hideDigitization = hideDigitizationUi(userData?.company?.id)

	const { dailyStatistics, loadingStatistics, error } = useAppSelector(
		state => state.cattlesSlice,
	)
	useEffect(() => {
		!dailyStatistics && dispatch(fetchDailyStatistics(activeFilter))
	}, [activeFilter, dailyStatistics, dispatch])
	const isExpiredLicense = error?.status === 450
	return (
		<PageContainer>
			{permissions?.license_identification && (
				<>
					<Collapse
						in={
							dailyStatistics?.issues?.repeat_identification &&
							dailyStatistics?.identified_count?.unidentified > 0
						}
						timeout='auto'
						unmountOnExit
					>
						<RepeatIdentifiedCard />
					</Collapse>
					{!hideDigitization && (
						<DigitizationWidjet
							isExpiredLicense={isExpiredLicense}
							loadingStatistics={loadingStatistics}
							digitizated={dailyStatistics?.identified_count}
						/>
					)}
				</>
			)}
			{/* {(permissions?.license_fatness ||
				permissions?.license_identification ||
				permissions?.license_limpness) && (
				<WidjetsHeader
					loadingStatistics={loadingStatistics}
					dailyStatistics={dailyStatistics}
				/>
			)} */}
			<CattlesList activeFilter={activeFilter} />
		</PageContainer>
	)
}

export default CattlesPage
